import { useEffect, useRef, useState } from 'react'
import { Link, NavLink, useLocation } from 'react-router'
import logo from '../assets/logo.png'
import { IconMenu } from './Iconen'
import { hoofdnavigatie } from '../routes'

/*
 * De header uit legacy/current, met dezelfde opbouw en dezelfde klassen.
 *
 * Twee dingen werken anders dan in het origineel, allebei omdat de routes
 * geprerenderd worden (ADR-0011) en de pagina dus al bruikbaar moet zijn voordat
 * de bundel geladen is:
 *
 * - Het mobiele menu is een <details> in plaats van een knop met een
 *   klasse-omschakeling. Het ziet er hetzelfde uit en staat op dezelfde plek,
 *   maar het werkt ook zonder JavaScript. Zonder die wijziging zou een bezoeker
 *   op een telefoon alleen via de footer kunnen navigeren.
 * - De links zijn react-router-links, zodat navigeren geen volledige paginalading
 *   is.
 *
 * De `is-stuck`-schaduw bij het scrollen is wel gewoon overgenomen.
 */
export default function Header() {
  const location = useLocation()
  const menu = useRef<HTMLDetailsElement>(null)
  const [vast, setVast] = useState(false)

  useEffect(() => {
    const bijScroll = () => setVast(window.scrollY > 8)
    bijScroll()
    window.addEventListener('scroll', bijScroll, { passive: true })
    return () => window.removeEventListener('scroll', bijScroll)
  }, [])

  // Bij navigatie blijft de DOM staan, dus een opengeklapt menu ook.
  useEffect(() => {
    if (menu.current) menu.current.open = false
  }, [location])

  return (
    <header className={vast ? 'header is-stuck' : 'header'}>
      <div className="wrap">
        <nav className="nav" aria-label="Hoofdnavigatie">
          <Link
            className="brand"
            to="/"
            aria-label="GPKeuringen, naar de homepage"
          >
            <span className="brand__mark" aria-hidden="true">
              <img src={logo} alt="" />
            </span>
            <span className="brand__text">
              <span className="brand__name">GPKeuringen</span>
              <span className="brand__sub">
                Onafhankelijk sociaal-medisch advies
              </span>
            </span>
          </Link>

          <div className="nav__menu">
            {hoofdnavigatie.map((route) => (
              <NavLink key={route.pad} to={route.pad} end>
                {route.label}
              </NavLink>
            ))}
          </div>

          <div className="nav__actions">
            <Link to="/#aanvraag" className="btn btn--primary">
              Vraag aan
            </Link>

            {/*
              De hamburger staat hier, naast de knop, net als op de bestaande
              site: .nav__actions is een flexrij en zet ze met 8px ertussen naast
              elkaar. Alleen het uitklappaneel wordt absoluut gepositioneerd —
              dat moet binnen dezelfde <details> blijven, maar over de volle
              breedte onder de header hangen.
            */}
            <details className="nav__mobile" ref={menu}>
              <summary className="nav__toggle" aria-label="Menu">
                <IconMenu />
              </summary>
              <div className="mobile-menu">
                <div className="wrap">
                  {hoofdnavigatie.map((route) => (
                    <NavLink key={route.pad} to={route.pad} end>
                      {route.label}
                    </NavLink>
                  ))}
                  <Link to="/#aanvraag" className="btn btn--primary">
                    Vraag aan
                  </Link>
                </div>
              </div>
            </details>
          </div>
        </nav>
      </div>
    </header>
  )
}
